<app-toast-message></app-toast-message>
<div class="user-list-container" style="padding-bottom: var(--footer-height, 56px); box-sizing: border-box;">
  <app-table
    [data]="userData"
    [columns]="userColumns"
    [rows]="userPageSize"
    [showPaginator]="true"
    [showSort]="false"
    [showFilter]="true"
    [loading]="userLoading"
    [globalFilterFields]="userGlobalFilterFields"
    [actions]="userActions"
    [filterConfig]="userFiltersConfig"
    [(filterValue)]="userFiltersValue"
    (searchClicked)="onUserSearchClicked($event)"
    [totalRecords]="userTotalRecords"
    (lazyLoadData)="onLazyLoadEventFromTable($event)"
    (viewCertificateEvent)="onViewCertificate($event)"
  >
  </app-table>

  <!-- Anchored list popup (dialog) -->
  <dialog class="list-popup" [open]="listPopupVisible" [style.left.px]="listPopupX" [style.top.px]="listPopupY" aria-label="More items">
    <div class="popup-header">
      <span>{{ listPopupTitle }}</span>
      <button type="button" aria-label="Close" (click)="closeListPopup()">✕</button>
    </div>
    <ul class="popup-list">
      <li *ngFor="let c of listPopupItems">{{ c }}</li>
    </ul>
  </dialog>
</div>

<!-- User Form Dialog (for both create and edit) -->
<app-user-form
  [visible]="showUserFormDialog"
  [editMode]="isEditMode"
  [userData]="selectedUserForEdit"
  (visibleChange)="showUserFormDialog = $event"
  (closeDialog)="onUserFormClosed()"
  (userCreated)="onUserCreated($event)"
  (userUpdated)="onUserUpdated($event)"
  (viewCertificateEvent)="onViewCertificate($event)"
></app-user-form>

<!-- PrimeNG Dialog for PDF Viewer -->
<p-dialog
  [header]="pdfFileName"
  [(visible)]="displayPdfViewer"
  [modal]="true"
  [style]="{ width: '70vw', height: '80vh' }"
  [draggable]="false"
  [resizable]="false"
  (onHide)="pdfUrl = null"
  styleClass="pdf-viewer-dialog"
>
  <ng-container *ngIf="safePdfUrl as sUrl">
    <iframe
      [src]="sUrl"
      style="width: 100%; height: calc(80vh - 4rem); border: none; background: #1e1e1e;"
      title="PDF preview"
    ></iframe>
  </ng-container>
  <ng-template pTemplate="footer">
    <!-- Optional: Add buttons in the footer if needed -->
  </ng-template>
</p-dialog>